var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-page-top-section',{attrs:{"title":_vm.$t('expense_report'),"icon":"briefcase"}}),_vm._v(" "),(_vm.options.url)?_c('app-table',{attrs:{"id":_vm.table_id,"options":_vm.options},on:{"action":function($event){}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }